import Request from "@/services/api/Request";

import { API_URL } from "@/constants";

export const routes = {
  login: `${API_URL}/auth/login`,
  register: `${API_URL}/auth/registration`,
  registerArtist: `${API_URL}/auth/registration-artist`,
  forgotPassword: `${API_URL}/auth/forgot-password`,
  resetPassword: `${API_URL}/auth/reset-password`,
  logout: `${API_URL}/auth/logout`,
  verify: `${API_URL}/email/verify`
};

export const request = new Request("user");

export default {
  login(params) {
    return request.post(routes.login, params);
  },
  register(params) {
    return request.post(routes.register, params);
  },
  registerArtist(params) {
    return request.post(routes.registerArtist, params);
  },
  forgotPassword(params) {
    return request.post(routes.forgotPassword, params);
  },
  resetPassword(params) {
    return request.post(routes.resetPassword, params);
  },
  logout() {
    return request.post(routes.logout);
  },
  verify(params) {
    return request.post(routes.verify, params);
  }
};
